import settings from '../settings.js'

import loginModalHtml from '../templates/login.html'

export default function (scope, state, ionicModal, ionicPopup, common, UserService, FitnessService, Idle, ionicHistory, timeout, document, toastr) {
    scope.forgottenPassword = false;

    ionicModal.fromTemplateUrl(loginModalHtml, {
        scope: scope
    }).then((modal) => {
        scope.loginModal = modal;
    });

    let loginSuccessAction;

    if (!settings.useLocalFitness) { //Don't do this for local Jumppakalenteri
        if (UserService.user.access_token) { //We have sessionId. Verify that its still valid!
            common.log("Found stored session for user '" + UserService.user.username + "'. sessionId: " + UserService.user.access_token, true);
            
            UserService.loginData.loginState = 1; //Login in progress

            if (settings.stateFront !== 'app.front')
                state.go('app.front');

            //Fetch session data with access token. Rejects as error if no token set.
            UserService.getSessionData().then((res) => {
                if (!res.isValid) { //If not valid, we need to login again
                    if (res.data.access_token)
                        common.log("Stored session was invalid. New login required. New sessionId: " + res.data.access_token, true);

                    UserService.loginData.loginState = 0; //Login failure
                }
                else { //Session still valid. Proceed.
                    if (res.data.access_token)
                        common.log("Stored session verified as valid. Using sessionId: " + res.data.access_token, true)

                    loginSuccessAction();                                
                }
            }).catch((error) => {
                console.log("error", error);

                UserService.loginData.loginState = 0; //Login failure
                common.writeToServerErrorLog('logTypeMisc', "Error fetching session data: " + JSON.stringify(error));

                ionicPopup.alert({
                    title: _locale('login error').ucfirst(),
                    template: _locale('There was an error during login.') + '<br><br>' +
                                _locale('make sure your network connection is working properly.').ucfirst() + '<br><br>' + 
                                _locale('if the error recurs, please contact support.').ucfirst()       
                });
            });
        }
        else { //No access token and no login/password. Cannot autologin.
            UserService.loginData.loginState = 0; //Login failure  
        }
    };

    let loginClicked = false;

    //Normal modal user/password login
    scope.doLogin = () => {
        if (loginClicked)
            return;

        const loginSuccess = (response) => {
            if (response.data.access_token)
                common.log("Logged in user '" + UserService.user.username + "'. Using sessionId: " + response.data.access_token, true);

            loginSuccessAction()

            loginClicked = false;
        };

        const loginFailure = (response) => {
            loginClicked = false;

            const popupPromise = ionicPopup.show({
                title: _locale('error during login').ucfirst(),
                template: _locale('user name and password do not match.').ucfirst() + '<br><br>' + _locale('please try again, or request a new password.').ucfirst(),
                scope: scope,
                cssClass: "popup-vertical-buttons",
                buttons: [{
                    text: 'OK',
                    onTap: (e) => false
                }, {
                    text: _locale('forgot your password?').ucfirst(),
                    onTap: (e) => true
                }]
            });
            
            popupPromise.then((forgotPassword) => scope.forgottenPassword = forgotPassword);
            common.ionicPopupHandler(popupPromise, 3000);
        }

        loginClicked = true;

        UserService.authorize(scope.loginData.username, scope.loginData.password).then(loginSuccess).catch(loginFailure);
    };

    loginSuccessAction = () => {
        const promises = [
            UserService.getMobileAppSettings(),
            common.getServerAppData(false, false, false)
        ];

        //TODO: Should probably do this only after getMobileAppSettings is finished! Right now fitnessEnabled being true ONLY on server has issues.        
        if (settings.fitnessEnabled) {
            promises.push(FitnessService.getFitnessData());
            console.log("[" + performance.now() + "] Calling FitnessService.getFitnessData() and FitnessService.refreshLastEntryTime() from initLogin loginSuccessAction()");
        }

        //0 = getMobileAppSettings, 1 = getFitnessData
        Promise.all(promises.map(p => p.catch((e) => e))).then((response) => {
            //If there were no errors, these are all true
            const [getMobileAppSettings, getServerAppData, getFitnessData] = response;

            if (!getMobileAppSettings || (settings.fitnessEnabled && !getFitnessData)) {
                console.log(`[${performance.now()}] Error fetching data on login! getMobileAppSettings=${getMobileAppSettings}, getServerAppData=${getServerAppData}, getFitnessData=${getFitnessData}`);
                //TODO: Handle error here? Popup?
            }

            UserService.loginData.loginState = 2; //Login done successfully

            console.log(`[${performance.now()}] Login complete!`);

			//Close login popup
            scope.closeLogin();

            if (settings.useLocalFitness) //Dont autologout during development for password logins
                Idle.watch();

            const current = ionicHistory.currentView();

            if (current.stateId !== 'app.fitness') {
                ionicHistory.clearCache().then(() => {
                    state.go('app.fitness');
                });
            }

            scope.$broadcast('User:loggedIn');
        })
        .catch((error) => {
            UserService.loginData.loginState = 0; //Login failure

            common.writeToServerErrorLog('logTypeMisc', "loginSuccessAction data retrieval returned error: " + JSON.stringify(error));

            const popupPromise = ionicPopup.alert({
                        title: _locale('login error').ucfirst(),
		                template: _locale('error fetching data from server.').ucfirst() + '<br><br>' +
		                         _locale('please restart program and try again.').ucfirst() + '<br><br>'
		                          + _locale('if the error recurs, please contact support.').ucfirst()
            });

            common.ionicPopupHandler(popupPromise, 3000);
        });      
    };

    scope.$on('User:loginSuccessAction', () => loginSuccessAction());

    /*
    scope.hakaLoginClicked = false;

    //Haka login used by CampusMoWe only.
    scope.doHakaLogin = (newAccessToken = false) => { //Do HAKA login via inAppBrowser
        if (scope.hakaLoginClicked)
            return;

        scope.hakaLoginClicked = true;

        let url = 'https://wisedemo5.fi/' + '?action=haka&type=login&appLogin=1&lang=' + UserService.langCode;

        if (newAccessToken) //If new sessionId given, use it instead
            url += '&access_token=' + newAccessToken;

        const options = 'location=yes,hidenavigationbuttons=yes,hideurlbar=yes,toolbarcolor=#d8641d,closebuttoncaption=' + _locale('cancel').ucfirst() + ',closebuttoncolor=#ffffff,hardwareback=no';

        console.log("Haka login: InAppBrowser opening url = '" + url + "'");

        let hakaWindow = window.open(url);

        let leftDomain = false;

        const hakaInterval = setInterval(() => {
            try {
                console.log("hakaWindow.document.domain", hakaWindow.document.domain);
                console.log("document.domain", document, document.domain);
                if (hakaWindow.document.domain === document.domain) {
                    console.log("hakaWindow.document.readyState: ", hakaWindow.document.readyState);
                    if (leftDomain && hakaWindow.document.readyState === "complete") {
                        clearInterval(hakaInterval);
                        alert("Haka returned!");
                    }
                }
                else {
                    leftDomain = true;    
                }
            } catch (error) {
                console.log("error", error);

                try {
                    console.log("hakaWindow.closed", hakaWindow.closed);
                    if (hakaWindow.closed) {
                        clearInterval(hakaInterval);
                        alert("Haka window closed!");
                        return;
                    }
                } catch (error2) {                    
                }


                leftDomain = true;
            }
        }, 500);

        return;

        let InAppBrowserRef = cordova.InAppBrowser.open(url, '_blank', options);

        InAppBrowserRef.addEventListener('loadstop', loadStopCallBack);
        InAppBrowserRef.addEventListener('loaderror', loadErrorCallBack);

        function loadErrorCallBack(params) {
            scope.hakaLoginClicked = false;
            InAppBrowserRef.close();
            InAppBrowserRef = undefined;

            common.writeToServerErrorLog('logTypeMisc', "Error on HAKA login: " + params.message);

            ionicPopup.alert({
                title: _locale('login error').ucfirst(),
                template: _locale('There was an error during login. If the situation recurs, please contact support.').ucfirst()
            });
        };

        function loadStopCallBack(data) {
            if (scope.hakaLoginClicked)
                scope.hakaLoginClicked = false;

            if (data.url.includes('?action=haka&type=complete') || data.url.includes('?action=saml&type=complete')) {
                InAppBrowserRef.executeScript({code: `sessionId`}, (sessionData) => {
                    console.log("HAKA login complete. Received sessionId: " + sessionData[0].sessionId);

                    UserService.user.access_token = sessionData[0].sessionId;

                    UserService.getSessionData().then((res) => {
                        if (!res.isValid) { //If not valid, we need to login again
                            if (res.data.access_token)
                                common.log("Stored session was invalid. New login required. New sessionId: " + res.data.access_token, true);

                                UserService.loginData.loginState = 0;

                            if (InAppBrowserRef) { //Close HAKA inAppBrowser on HAKA login success
                                InAppBrowserRef.close();
                                InAppBrowserRef = undefined;
                            }

                            ionicPopup.alert({
                                title: _locale('login error').ucfirst(),
                                template: _locale('There was an error during login. If the situation recurs, please contact support.').ucfirst()
                            });
                        }
                        else { //Session still valid. Proceed.
                            if (res.data.access_token)
                                common.log("Stored session verified. Using sessionId: " + res.data.access_token, true)

                            UserService.loginData.loginState = 2;

                            scope.registerPushNotifications();
                            loginSuccessAction(InAppBrowserRef);                                
                        }
                    })
                    .catch((error) => {
                        console.log("error" , error);

                        UserService.loginData.loginState = 0;

                        if (InAppBrowserRef) { //Close HAKA inAppBrowser on HAKA login success
                            InAppBrowserRef.close();
                            InAppBrowserRef = undefined;
                        }

                        ionicPopup.alert({
                            title: _locale('login error').ucfirst(),
                            template: _locale('There was an error during login. If the situation recurs, please contact support.').ucfirst()
                        });
                    });
                });
            }
        }
    };
    */

    scope.login = () => {
        scope.loginModal.show();
    };

    scope.logout = () => {
		return new Promise((resolve, reject) => {
            const logoutFinally = () => {
                console.log("Running logoutFinally");

                UserService.loginData.loginState = 0;
                UserService.loginData.isTagLogin = false;

                state.go(settings.stateFront);

                ionicHistory.clearCache();
                ionicHistory.clearHistory();

                if (settings.useLocalFitness)
                    Idle.unwatch();

                scope.$broadcast('User:loggedOut');

                resolve(true);
            };

            if (!UserService.loginData.isTagLogin) {
                UserService.logout().then(() => logoutFinally());
            }
            else {
                UserService.loginData.tagData = {
                    tagUID: false,
                    techTypes: []
                };

                UserService.setDetails({
                    personId: null,
                    tagData: UserService.loginData.tagData
                });

                logoutFinally();
            }
        });
    };

    scope.closeLogin = () => {
        if (scope.loginModal && scope.loginModal.isShown())
            scope.loginModal.hide();
    };
    
    scope.forgottenPasswordChange = () => scope.forgottenPassword = !scope.forgottenPassword;

    let forgotClicked = false;

    scope.forgotPassword = () => {
        if (forgotClicked)
            return;

        if (!scope.loginData.username) {
            return ionicPopup.alert({
                title: _locale('forgotten password').ucfirst(),
                template: _locale('please input valid username').ucfirst()
            });
        }

        forgotClicked = true;

        const doForgotPassword = (baseUrl = null, appAuthSecret = null) => {
            UserService.forgotPassword(scope.loginData.username, baseUrl, appAuthSecret).then((result) => {
                if (result.data.errors) {
                    const errorMessage = result.data.errors[0];
                    const resultText = errorMessage.errno === 5 ? _locale('check validity of email address').ucfirst() : _locale(errorMessage.error).ucfirst();

                    return ionicPopup.alert({
                        title: _locale('forgotten password').ucfirst(),
                        template: _locale(resultText).ucfirst()
                    });
                }

                ionicPopup.alert({
                    title: _locale('forgotten password').ucfirst(),
                    template: _locale('link sent to your email').ucfirst()
                });
            }).finally(() => {
                forgotClicked = false;
            })
        };

        doForgotPassword();
    };

    const tagLoginNew = async (tagData) => {
        if (scope.loginModal.isShown()) {
            scope.loginModal.hide();
        }
        
        const locationId = (fitCalLocationId && fitCalLocationId != -1) ? fitCalLocationId : 1;

        try {
            const response = await UserService.doTagLogin(tagData, locationId);

            if (!response.data.success) {
                UserService.loginData.loginState = 0;
                throw response;
            }

            //Someone already logged in!
            if (UserService.user.personId) {
                if (UserService.user.personId === response.data.personId) { //If same person logged in, just go to fitness page
                    ionicHistory.clearCache().then(() => {
                        state.go('app.fitness');
                    });

                    scope.$broadcast('Fitness:reset'); //Search reset
                    return true;

                }
                else { //If someone else already logged in, logout them first and then relogin with tag
                    await scope.logout();
                }
            }

            UserService.loginData.loginState = 1;
            
            console.log(response.data);
            
            
        } catch (error) {
            scope.logout();

            const popupPromise = ionicPopup.show({
                title: _locale('error logging in').ucfirst()    ,
                template: error.data.error ? error.data.error : _locale("unknown error").ucfirst(), 
                scope: scope,
                cssClass: "popup-vertical-buttons",
                buttons: [{
                    text: 'OK',
                    onTap: (e) => false
                }]
            });

            common.ionicPopupHandler(popupPromise, 3000);
        }
    };

    /* BEGIN TAGLOGIN */
    const tagLogin = (tagData) => {
        if (scope.loginModal.isShown())
            scope.loginModal.hide();

        const tagLoginSuccess = (response) => {
            if (response.data.success) {
                //Did we add row to AccessControlEvents?
                const accessEventAdded = !!response.data.accessEventAdded;
                
                const validAccessFound = !!response.data.validAccessFound;
                const validAccessRequired = !!response.data.validAccessRequired;

                console.log(`accessEventAdded: ${(accessEventAdded ? 'true' : 'false')}, validAccessFound: ${(validAccessFound ? 'true' : 'false')}`);

                if (!validAccessFound && validAccessRequired) {
                    const popupPromise = ionicPopup.show({
                        title: _locale('no access right').ucfirst(),
                        template: _locale('sorry, you do not have a valid pass.').ucfirst(),
                        scope: scope,
                        cssClass: "bigger-popup",
                        buttons: [{
                            text: 'OK',
                            onTap: (e) => false
                        }]
                    });

                    UserService.loginData.loginState = 0;
        
                    common.ionicPopupHandler(popupPromise, 5000);
                    return false;
                }

                UserService.loginData.loginState = 2;
                UserService.loginData.isTagLogin = true;
                UserService.loginData.tagData = tagData;

                UserService.setDetails({
                    personId: response.data.personId,
                    firstName: response.data.firstName,
                    familyName: response.data.familyName,
                    tagData: UserService.loginData.tagData
                });

                const promises = [
                    UserService.getMobileAppSettings(),
                    common.getServerAppData(false, false, false),
                    FitnessService.getFitnessData()
                ];

                Promise.all(promises.map(p => p.catch(() => undefined))).then((response) => {
                    const [getMobileAppSettings, getServerAppData, getFitnessData] = response;

                    if (settings.useLocalFitness) {
                        if (!getMobileAppSettings || !getFitnessData) {
                            //Something went wrong
                            scope.logout();
                        }

                        const finishLogin = () => {
                            ionicHistory.clearCache().then(() => {
                                state.go('app.fitness');
                                scope.$broadcast('User:taggedIn');

                                Idle.watch();
                            });
                        };

                        //If we added a row to AccessControlEvents, do special handling.
                        if (accessEventAdded) {
                            //Are there any events that the user can enroll to?
                            const canEnroll = settings.fitnessEnabled && FitnessService.fitnessEvents.some((fitnessEvent) => fitnessEvent.hasEventEnrollPermission);
                            const locationId = (fitCalLocationId && fitCalLocationId != -1) ? fitCalLocationId : 1;

                            const showPopup = (title, template, extraMsg = '') =>  {
                                const popupPromise = ionicPopup.show({
                                    title: title,
                                    template: template + (extraMsg ? "<br><br>" + _locale(extraMsg).ucfirst() : ""),
                                    scope: scope,
                                    cssClass: "bigger-popup",
                                    buttons: [{
                                        text: 'OK',
                                        onTap: (e) => false
                                    }]
                                });

                                common.ionicPopupHandler(popupPromise, 5000);

                                return popupPromise;
                            };

                            let popupExtraMsg = '';
                            let popupTitle = _locale('registering').ucfirst();
                            let popupTemplate = _locale('you have been registered in.').ucfirst();

                            if (common.validUntilArray[locationId] && common.validUntilArray[locationId].length) {
                                const validData = common.validUntilArray[locationId][0];

                                if (validData.usableQuantity) {
                                    const newQuantity = validData.usableQuantity - 1;

                                    if (!newQuantity) {
                                        popupExtraMsg = _locale('you have no visits left after this.').ucfirst();
                                    }
                                    else {
                                        popupExtraMsg = _locale('you will have %s visits left after this.', newQuantity).ucfirst();
                                    }
                                }
                                else if (validData.validTo) {
                                    popupExtraMsg = _locale('your access right is valid until %s.', moment(validData.validTo).format('DD.MM.YYYY')).ucfirst();
                                }
                            }

                            if (!canEnroll || settings.showLoginPopup) {
                                if (settings.showLoginPopup && !popupExtraMsg) {
                                    const fullName = UserService.user ? ((UserService.user.firstName + ' ' + UserService.user.familyName).trim()) : '';
    
                                    if (fullName) {
                                        popupTitle = _locale('you are logged in').ucfirst();
                                        popupTemplate = _locale('welcome').ucfirst() +  ` ${fullName}!`;
                                    }
                                }

                                showPopup(popupTitle, popupTemplate, popupExtraMsg).then(() => {
                                    if (canEnroll && !settings.fitnessSkipEventList) {  //User can enroll, finish login.
                                        finishLogin();                                        
                                    }
                                    else { //If user cannot enroll, abort.
                                        scope.logout();
                                    }
                                });
                            }
                            else {                                
                                if (!settings.fitnessSkipEventList) {
                                    finishLogin();
                                }
                                else {
                                    scope.logout();
                                }
                            }
                        }
                        else { //Skip special handling
                            if (settings.fitnessEnabled && !settings.fitnessSkipEventList) { //If fitness is enabled, allow user to view fitness events even if he has no access right.
                                finishLogin();
                            }
                            else { //Otherwise just tell user that he has no access rights.
                                const popupPromise = ionicPopup.show({
                                    title: _locale('no access right').ucfirst(),
                                    template: _locale("you weren't registered in.").ucfirst() + "<br><br>" + _locale('sorry, you do not have a valid pass.').ucfirst(),
                                    scope: scope,
                                    cssClass: "bigger-popup",
                                    buttons: [{
                                        text: 'OK',
                                        onTap: (e) => false
                                    }]
                                });
                    
                                common.ionicPopupHandler(popupPromise, 5000);
    
                                scope.logout();
                            }
                        }
                    }
                });
            }
            else {
                UserService.loginData.loginState = 0;
            }
        };

        const tagLoginFail = (response) => {
            console.log("tagLoginFail", response);
            scope.logout();

            const popupPromise = ionicPopup.show({
                title: _locale('error logging in').ucfirst()    ,
                template: response.data.error ? response.data.error : _locale("unknown error").ucfirst(), 
                scope: scope,
                cssClass: "popup-vertical-buttons",
                buttons: [{
                    text: 'OK',
                    onTap: (e) => false
                }]
            });

            common.ionicPopupHandler(popupPromise, 3000);
        };

        const locationId = (fitCalLocationId && fitCalLocationId != -1) ? fitCalLocationId : 1;

        UserService.doTagLogin(tagData, locationId).then((response) => {
            if (!response.data.success)
                return tagLoginFail(response);

            if (UserService.user.personId) {
                if (UserService.user.personId === response.data.personId && settings.fitnessEnabled && !settings.fitnessSkipEventList) { //If same person logged in, just go to fitness page
                    ionicHistory.clearCache().then(() => {
                        state.go('app.fitness');
                    });
                    scope.$broadcast('Fitness:reset'); //Search reset
                }
                else { //If someone else already logged in, logout first and then relogin with tag
                    UserService.loginData.loginState = 1;
                    scope.logout().then(() => tagLoginSuccess(response));
                }
            }
            else { //Tag login new user
                UserService.loginData.loginState = 1;
                tagLoginSuccess(response);
            }
        }).catch(tagLoginFail);
    };

    /* BEGIN KEYPRESS LISTENER FOR TAGLOGIN */
    let keyPressTimeout = null;
    let keyString = '';

    const handleKeyString = () => {
        const tagCode = keyString;

        keyPressTimeout = null;
        keyString = '';

        if (tagCode.length <= 5 || UserService.loginData.loginState !== 0)
            return false;

        tagLogin({
            tagUID: tagCode,
            techTypes: null
        });        
    };

    const keyupHandler = (keyEvent) => {
        if (UserService.loginData.loginState !== 0 || isNaN(parseInt(keyEvent.key)) || !settings.useLocalFitness)
            return false;

        if (keyPressTimeout) //Reset timeout on keypress
            timeout.cancel(keyPressTimeout);
        
        keyString += keyEvent.key;

        keyPressTimeout = timeout(handleKeyString, 50); //Run handleKeyString when 50msec since last keypress
    }; 

    if (settings.useLocalFitness) { //Check for key inputs only locally
        document.on('keyup', keyupHandler);
        scope.$on('$destroy', () => document.off('keyup', keyupHandler));
    }
}